export default (items: any[], item: any, add: boolean) => {
  const position = items.findIndex(i => i.id === item.id);
  if (position < 0) {
    if (add) {
      return [...items, item];
    }
    return items;
  }
  const result = [...items];
  if (add) {
    result[position] = item;
  } else {
    result.splice(position, 1);
  }
  return result;
};
